import { render, staticRenderFns } from "./EventWorkflow.vue?vue&type=template&id=6d333f5f"
import script from "./EventWorkflow.js?vue&type=script&lang=js&external"
export * from "./EventWorkflow.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports